import HotWorkApproval from '../../../modules/superAdmin/HotWorkApproval';
import HotWorkApprovalDetail from '../../../modules/superAdmin/HotWorkApproval/HotWorkApprovalDetail';
import Settings from '../../../modules/superAdmin/Settings';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';

const routes = [
  { path: '/HotWorkApproval', element: <HotWorkApproval /> },
  { path: '/HotWorkApproval/:id', element: <HotWorkApprovalDetail /> },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
  { path: '/notifications', element: <NotificationList /> },
];

export default routes;
